import { theme, ThemeConfig } from 'antd';

const { darkAlgorithm, defaultAlgorithm } = theme;

// Cary brand colors
export const caryColors = {
  primary: '#9fe970',
  secondary: '#52c41a',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  info: '#9fe970',
  text: '#082a0b',
  textSecondary: '#00000073',
  border: '#d9d9d9',
  background: '#ffffff',
  backgroundSecondary: '#fafafa',
} as const;

export const lightTheme: ThemeConfig = {
  algorithm: defaultAlgorithm,
  token: {
    colorPrimary: caryColors.primary,
    colorSuccess: caryColors.success,
    colorWarning: caryColors.warning,
    colorError: caryColors.error,
    colorInfo: caryColors.info,
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      bodyBg: '#f5f5f5',
    },
    Menu: {
      itemSelectedBg: '#9fe970',
      itemHoverBg: '#f0fce8',
      itemSelectedColor: caryColors.text,
    },
    Card: {
      borderRadiusLG: 8,
    },
    Button: {
      borderRadius: 6,
      primaryColor: caryColors.text,
      defaultHoverBg: '#9fe970',
      defaultHoverBorderColor: '#9fe970',
      defaultHoverColor: caryColors.text,
    },
    Typography: {
      colorLink: caryColors.text,
      colorLinkHover: caryColors.text,
      linkHoverDecoration: 'underline',
    },
    Tabs: {
      itemActiveColor: '#0f453d',
      itemHoverColor: '#0f453d',
      itemSelectedColor: '#0f453d',
      inkBarColor: '#0f453d',
    },
    Tag: {
      marginXS: 0,  // This removes the margin-inline-end
    },
  },
};

export const darkTheme: ThemeConfig = {
  algorithm: darkAlgorithm,
  token: {
    colorPrimary: caryColors.primary,
    colorSuccess: caryColors.success,
    colorWarning: caryColors.warning,
    colorError: caryColors.error,
    colorInfo: caryColors.info,
    borderRadius: 6,
    wireframe: false,
  },
};